<template>
    <Modal v-model="isShow" title="查看数据" width="500" @on-ok="onOk" >
        <span>{{data}}</span>
    </Modal>
</template>
<script>
export default {
    props:['data'],
    data() {
        return {
            isShow:false
        }
    },
    methods: {
        show(){
            this.isShow = true;
        },

        onOk(){
            
        }
    },
}
</script>